<template>
    <div class="ls-past-disputes-view-footer--container">
        <div test-id="response">
            <p>Response Information</p>
            <div
                v-if="!selectedDispute.response"
                class="ls-past-disputes-view-footer--info"
                test-id="no-response"
            >
                <div>
                    <span>Provider has not responded.</span>
                </div>
                <div>
                    <span>Provider message:</span>
                    <span>N/A</span>
                </div>
                <div>
                    <span>Provider photos:</span>
                    <span>N/A</span>
                </div>
            </div>
            <!-- provider responded -->
            <div v-else class="ls-past-disputes-view-footer--info" test-id="responded">
                <div>
                    <span>Responded by:</span>
                    <span>{{ getProviderName }}</span>
                </div>
                <div>
                    <span>Response type:</span>
                    <span>{{ getResponseType }}</span>
                </div>
                <div>
                    <span>Response on:</span>
                    <span>{{ selectedDispute.response_set_at | timestamp }}</span>
                </div>
                <div>
                    <span>Provider message:</span>
                    <span>{{ getProviderComment }}</span>
                </div>
                <div class="ls-past-disputes-view-footer--dispute-images-container">
                    <span>Provider photos:</span>
                    <div v-if="selectedDispute.images.contractor.length" test-id="photos">
                        <LsImageRow
                            :images="selectedDispute.images.contractor"
                            class="ls-past-disputes-vie-footer--dispute-images"
                        />
                    </div>
                    <span v-else>N/A</span>
                </div>
            </div>
        </div>

        <!-- credit -->
        <div v-if="isCredit" class="ls-past-disputes-view-footer--info" test-id="credit">
            <div>
                <span>Credited on:</span>
                <span>{{ selectedDispute.credit_offered_at | timestamp }}</span>
            </div>
            <div>
                <span>Credited:</span>
                <span>{{ selectedDispute.credit_offered_amount | currency }}</span>
            </div>
        </div>
        <div v-if="getQaSchedule">
            <LsServiceList :services="[getQaSchedule]" @click="handleClick" />
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsFilters, lsPropTypeHelpers } from 'ls-vue-common';
import LsImageRow from '@/components/LsImageRow/LsImageRow.vue';
import LsServiceList from '@/components/LsServiceList/LsServiceList.vue';

const responseTypes = {
    expired: 'Expired',
    comment: 'Replied',
    declined: 'Declined',
    return: 'Return Visit',
};

export default {
    name: 'PastDisputesViewFooter',
    components: { LsImageRow, LsServiceList },
    props: {
        selectedDispute: VueTypes.shape({
            comments: VueTypes.arrayOf(
                VueTypes.shape({
                    text: VueTypes.string,
                }).loose
            ),
            dispute_status: VueTypes.string.isRequired,
            response: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
            response_set_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
            images: VueTypes.shape({
                customer: VueTypes.arrayOf(VueTypes.object),
                contractor: VueTypes.arrayOf(VueTypes.object),
            }).isRequired.loose,
            credit_offered_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
            credit_offered_amount: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
        }).isRequired.loose,
        services: VueTypes.arrayOf(
            VueTypes.shape({
                next_scheduleevent_id: VueTypes.number,
            }).loose
        ),
    },
    data() {
        return {
            responseTypes,
        };
    },
    computed: {
        isCredit() {
            return this.selectedDispute.dispute_status === 'credit';
        },
        getProviderName() {
            const user = _.get(this.selectedDispute, 'schedule_event.contractor.user');

            return user ? lsFilters.fullName({ user }) : 'N/A';
        },
        getResponseType() {
            return responseTypes[this.selectedDispute.response] || this.selectedDispute.response;
        },
        getProviderComment() {
            // we are making the assumption the second comment
            // in the array is the provider response
            return _.get(this.selectedDispute.comments, '[1].text', 'N/A');
        },
        getQaSchedule() {
            return _.find(this.services, (service) => {
                return service.next_scheduleevent_id === this.selectedDispute.qa_schedule_event_id;
            });
        },
    },
    methods: {
        handleClick({ id, __typename }) {
            const routeName = _.camelCase(__typename);

            this.$router.push({
                name: routeName,
                params: {
                    customer_id: this.$route.params.customer_id,
                    property_id: this.$route.params.property_id,
                    [`${routeName}_id`]: id,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-past-disputes-view-footer--container {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px dashed $secondary;

    p {
        color: $primary;
        font-weight: $semi-bold;
    }

    > div:last-of-type {
        padding-top: 10px;
    }
}

.ls-past-disputes-view-footer--info {
    padding: 7px 0;

    div {
        padding: 7px 0;
        span:first-child {
            font-weight: $semi-bold;
            padding-right: 5px;
        }
    }
}

.ls-past-disputes-view-footer--dispute-images-container {
    span:first-child {
        font-weight: $semi-bold;
        padding-right: 5px;
    }

    .ls-past-disputes-view-footer--dispute-images {
        margin-top: 14px;
    }
}
</style>
